import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {map, Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';
import {GiftCard, mapGiftCard, mapGiftCards} from '../../../core/entities/gift-card/gift-card.entity';

export interface GiftCardCheckoutSession {
  sessionId: string;
  checkoutUrl: string;
  expiresAt?: string | null;
}

export interface GiftCardPurchasePayload {
  buyerEmail: string;
  senderFirstName?: string;
  recipientEmail: string;
  recipientFirstName?: string;
  deliveryDate?: string | null;
  amount: number;
  message?: string;
}

@Injectable({
  providedIn: 'root'
})
export class GiftCardService {
  public constructor(
    private readonly http: HttpClient,
  ) {}

  public getMyGiftCards(): Observable<GiftCard[]> {
    return this.http
      .get<any[]>(`${environment.apiUrl}/api/gift-cards`)
      .pipe(map(mapGiftCards));
  }

  public getGiftCard(code: string): Observable<GiftCard> {
    return this.http
      .get<any>(`${environment.apiUrl}/api/gift-cards/${code}`)
      .pipe(map(mapGiftCard));
  }

  public purchaseGiftCard(payload: GiftCardPurchasePayload): Observable<GiftCardCheckoutSession> {
    return this.http.post<GiftCardCheckoutSession>(
      `${environment.apiUrl}/api/gift-cards/purchase`,
      payload
    );
  }
}
